import { HTTPError } from '../libs';

export interface ApiClientConfig {
  serviceUrl: string;
}

export interface ApiClientInterface {
  init: (serviceTicket: string) => Promise<boolean>;
  verify: () => Promise<boolean>;
  subscribe: (config: { heartbeatTimeout: number }) => EventSource;
}

export enum ApiClientEvents {
  OPEN = 'onopen',
  ERROR = 'onerror',
  INIT = 'INIT',
  HEARTBEAT = 'HEARTBEAT',
  LOGOUT = 'LOGOUT',
}
export enum ApiClientState {
  CONNECTING = 0,
  OPEN = 1,
  CLOSED = 2,
}

export class ApiClient implements ApiClientInterface {
  private baseUrl: string;

  constructor({ serviceUrl }: ApiClientConfig) {
    this.baseUrl = serviceUrl;
  }

  public async init(serviceTicket: string) {
    const response = await fetch(`${this.baseUrl}/init?ticket=${serviceTicket}`, {
      credentials: 'include',
    });

    if (!response.ok) {
      throw new HTTPError(response);
    }

    return true;
  }

  public async verify() {
    const response = await fetch(`${this.baseUrl}/session`, { credentials: 'include' });

    if (!response.ok && response.status !== 401) {
      throw new HTTPError(response);
    }

    return response.ok;
  }

  public subscribe({ heartbeatTimeout }: { heartbeatTimeout: number }): EventSource {
    return new EventSource(`${this.baseUrl}/subscribe`, {
      withCredentials: true,
      // @ts-ignore: heartbeatTimeout is used by EventSourcePolyfill,
      // this property will be ignored by native EventSource
      heartbeatTimeout,
    });
  }
}
